<template>
  <div class="statistics">
    <div class="top">
      <div class="card">
        <div class="list" v-if="teamList.home.playerList && teamList.home.playerList.length > 0">
          <div class="item" :class="player && player.playerId === item.playerId ? 'active':''" v-for="(item, i) in teamList.home.playerList" :key="i" @click="selectPlayer(item)">
            <div>{{ item.number }}</div>
            <div>{{ item.trueName }}</div>
          </div>
        </div>
        <div class="list" v-else>无球员</div>
        <div class="info" v-if="player">
          <p>{{ getTeamName(player.teamId) }}</p>
          <img :src="imageView(player.avatar)" v-if="player.avatar" />
          <img src="https://images.snsports.cn/FrB9e_-z4Gj4879NuraIWmiVDkv_" v-else />
          <div>({{ player.number }}) {{ player.trueName }}</div>
        </div>
        <div class="info" v-else>未选择球员</div>
        <div class="list" v-if="teamList.away.playerList && teamList.away.playerList.length > 0">
          <div class="item" :class="player && player.playerId === item.playerId ? 'active' : ''" v-for="(item, i) in teamList.away.playerList" :key="i" @click="selectPlayer(item)">
            <div>{{ item.number }}</div>
            <div>{{ item.trueName }}</div>
          </div>
        </div>
        <div class="list" v-else>无球员</div>
      </div>
    </div>
    <div class="minute" v-if="player">
      <div class="title">
        <div class="icon"></div>
        <span>发球</span>
      </div>
      <MyField label="总数">
        <Stepper2 v-model="player.serviceCount"  @input="player.serviceCount = $event" background="#F9FAFC" />
      </MyField>
      <MyField label="ACE">
        <Stepper2 v-model="player.ace"  @input="player.ace = $event" background="#F9FAFC" />
      </MyField>
      <MyField label="成功数">
        <Stepper2 v-model="player.serviceWinCount"  @input="player.serviceWinCount = $event" background="#F9FAFC" />
      </MyField>
      <MyField label="得分">
        <Stepper2 v-model="player.point"  @input="player.point = $event" background="#F9FAFC" />
      </MyField>
      <div class="title">
        <div class="icon"></div>
        <span>破发</span>
      </div>
      <MyField label="破发点">
        <Stepper2 v-model="player.breakPoint"  @input="player.breakPoint = $event" background="#F9FAFC" />
      </MyField>
      <MyField label="成功破发">
        <Stepper2 v-model="player.breakPointSuccess"  @input="player.breakPointSuccess = $event" background="#F9FAFC" />
      </MyField>
      <div class="title">
        <div class="icon"></div>
        <span>失误</span>
      </div>
      <MyField label="非受迫性失误">
        <Stepper2 v-model="player.unforcedError"  @input="player.unforcedError = $event" background="#F9FAFC" />
      </MyField>
      <MyField label="双误">
        <Stepper2 v-model="player.doubleError"  @input="player.doubleError = $event" background="#F9FAFC" />
      </MyField>
      <div class="but" @click="goPages">
        查看完整统计
      </div>
    </div>
  </div>
</template>

<script>
import MyField from '../components/Field.vue'
import Stepper2 from '@/components/Stepper2.vue'
import { QNImageUtil } from '@/utils'
import {
  adminGetBMBktGameData,
  getBMMatchTennisGamePlayerList,
  updateBMMatchTennisGameStatic
} from "@/api/match";
export default {
  components: {
    MyField,
    Stepper2
  },
  data() {
    return {
      id: '',
      matchId:'',
      game: {},
      teamList: {
        home: {},
        away: {}
      },
      player:false
    }
  },
  mounted() {
    this.gameId = this.$route.query.gameId
    this.matchId = this.$route.query.matchId
    this.adminGetBMBktGameData()
  },
  methods: {
    getTeamName(id) {
      return this.game.homeTeam.id === id ? this.game.homeTeam.name : this.game.awayTeam.name
    },
    goPages() {
      this.$router.push({ path: '/match-manage/tennis-collect', query: { gameId: this.gameId, matchId: this.matchId }})
    },
    adminGetBMBktGameData() {
      adminGetBMBktGameData({ gameId: this.gameId }).then(res => {
        this.game = res.data.game
        const home = new Promise((resolve, reject) => {
          const params = {
            matchId: this.matchId,
            teamId: this.game.homeTeam.id,
            gameId: this.gameId
          }
          getBMMatchTennisGamePlayerList(params).then(res => {
            resolve(res)
          }).catch(e => {
            reject(e)
          })
        })
        const away = new Promise((resolve, reject) => {
          const params = {
            matchId: this.matchId,
            teamId: this.game.awayTeam.id,
            gameId: this.gameId
          }
          getBMMatchTennisGamePlayerList(params).then(res => {
            resolve(res)
          }).catch(e => {
            reject(e)
          })
        })
        this.getTeamList(home, away)
      })
    },
    getTeamList(home, away) {
      Promise.all([home, away]).then(results => {
        console.log('success:', results)
        const home = results[0]
        const away = results[1]
        this.teamList.home = home.data
        this.teamList.away = away.data
        if (home.data.playerList.length > 0) {
          this.player = home.data.playerList[0]
        } else if (away.data.playerList.length > 0) {
          this.player = away.data.playerList[0]
        } else {
          this.player = false
        }
        console.log(this.player);
      }).catch(e => { // 失败的时候则返回最先被reject失败状态的值
        console.log("error", e)
      })
    },
    selectPlayer(obj) {
      this.update().then(() => {
        this.player = obj
      })
    },
    update() {
      return new Promise((resolve) => {
        const params = {
          playerId: this.player.playerId,
          gameId: this.gameId,
          matchId: this.matchId,
          teamId: this.player.teamId,
          serviceCount: this.player.serviceCount,
          ace: this.player.ace,
          serviceWinCount: this.player.serviceWinCount,
          point: this.player.point,
          breakPoint: this.player.breakPoint,
          breakPointSuccess: this.player.breakPointSuccess,
          unforcedError: this.player.unforcedError,
          doubleError: this.player.doubleError
        }
        if(!params.playerId) return
        updateBMMatchTennisGameStatic(params).then((res) => {
          resolve(res)
        })
      })
    },
    imageView(img, w, h) {
      if (!img) return ''
      return QNImageUtil.imageView(img, w, h)
    },
  },
  beforeDestroy() {
    this.update()
  }
};
</script>

<style scoped lang="scss">
.statistics{
  .top{
    padding: 16px;
    background-color: #fff;
    .card{
      border-radius: 4px;
      background: #F3F5FA;
      padding: 12px;
      height: 219px;
      overflow: hidden;
      display: flex;
      justify-content: space-between;
    }
    .list{
      min-width: 72px;
      overflow: scroll;
      &::-webkit-scrollbar {
        /*隐藏滚轮*/
        display: none;
      }
      .item{
        width: 60px;
        height: 60px;
        background: #FFFFFF;
        border-radius: 2px;
        text-align: center;
        color: rgba(25,25,25,0.7);
        font-size: 14px;
        margin-bottom: 4px;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        padding: 0 6px;
      }
      .active{
        width: 58px;
        height: 58px;
        border: 1px solid #1565FC;
        color: #1565FC;
      }
    }
    .info{
      align-self: center;
      text-align: center;
      p{
        font-size: 14px;
        color: rgba(25,25,25,0.7);
        margin-bottom: 13px;
      }
      img{
        width: 90px;
        height: 120px;
        border-radius: 4px;
        border: 1px solid #E5E5E5;
      }
      div{
        font-size: 14px;
        font-weight: 500;
        color: #191919;
        margin-top: 12px;
      }
    }
  }
  .minute{
    margin-top: 12px;
    background-color: #fff;
    padding-left: 22px;
    padding-right: 16px;
    .but{
      color: #1565FC;
      font-size: 14px;
      padding: 17px 0;
      background-color: #fff;
      text-align: center;
    }
    .title {
      display: flex;
      align-items: center;
      font-weight: 500;
      font-size: 15px;
      color: #333333;
      padding: 25px 0 13px 0;
      border-bottom: 0.5px #EEEEEE solid;
      .icon {
        width: 2px;
        height: 12px;
        background-color: #7CCD19;
        margin-right: 6px;
      }
    }
  }
}
</style>
